import CustomButton from '../../../common/components/CustomButton';

type CopyrightCollectFormView3FieldName = 'applicant_address';

export default function CopyrightCollectFormView3({
  getValue,
  getItemCount,
  getItemValue,
  document,
  karaokeOrder,
  onPreviewEmail,
  onNext,
  onBack,
} : {
  getValue: (name: CopyrightCollectFormView3FieldName) => string,
  getItemCount: (collection: 'karaoke_authors') => number,
  getItemValue: (collection: 'karaoke_authors', index: number, name: 'pseudonym'|'email') => string,
  document: string,
  karaokeOrder: {
    applicant_name: string,
  },
  onPreviewEmail: () => void,
  onNext: () => void,
  onBack: () => void,
}) {
  return (
    <>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright_pt1.png" alt="著作権の手続き" />
        </div>
      </div>
      <h2>確認画面</h2>
      <p>入力された情報に誤りがないか確認してください。</p>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: document }} />
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <dt><label>乙</label></dt>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">名前:</span>
                    <span className="col span_18">{karaokeOrder.applicant_name}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">住所:</span>
                    <span className="col span_18">
                      {getValue('applicant_address')}
                    </span>
                  </li>
                </ul>
                <p className="c-gold">この内容で、以下の方に著作権譲渡契約の締結依頼を送ります。</p>
                <hr />
              </dd>
            </dl>
            {[...Array(getItemCount('karaoke_authors')).keys()].map((index) => (
              // eslint-disable-next-line react/no-array-index-key
              <dl key={index}>
                <dd>
                  <ul className="col" style={{ float: 'none' }}>
                    <li className="col span_24">
                      <span className="col span_6">筆名:</span>
                      <span className="col span_18">{getItemValue('karaoke_authors', index, 'pseudonym')}</span>
                    </li>
                    <li className="col span_24">
                      <span className="col span_6">メールアドレス:</span>
                      <span className="col span_18">{getItemValue('karaoke_authors', index, 'email')}</span>
                    </li>
                  </ul>
                </dd>
              </dl>
            ))}
            <CustomButton type="secondary-modal" onClick={() => onPreviewEmail()}>文章を確認</CustomButton>
            <ul>
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
                <CustomButton type="default-split" onClick={() => onNext()}>メール送信</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}

